import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { guestGuard } from './services/authentication/guest.guard';

const routes: Routes = [
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadChildren: () =>
      import('../app/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      )
  },
  {
    path: '',
    loadChildren: () =>
      import('../app/main/main.module').then(
        (m) => m.MainModule
      )
  },

  {
    redirectTo: 'auth',
    path: '**'
  }
  

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
